
      import API from "!../../build/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../build/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../build/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../build/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../build/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../build/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../build/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../build/loaders/strip-bom-loader.js!../../build/node_modules/postcss-loader/dist/cjs.js!./figma.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../build/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../build/loaders/strip-bom-loader.js!../../build/node_modules/postcss-loader/dist/cjs.js!./figma.css";
       export default content && content.locals ? content.locals : undefined;
